var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[(_vm.isDev && _vm.nodeId)?_c('i',{staticClass:"el-icon-edit edit-btn",on:{"click":_vm.dev}}):_vm._e(),_c('div',{staticClass:"amis-tpl",attrs:{"id":_vm.node}})])
}
var staticRenderFns = []

export { render, staticRenderFns }